import { addAllToRecord, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { OfficialGroupsLoadAction, OfficialGroupsLoadMoreAction } from '../../domains/officialGroups/actions.types';

import { OfficialGroups } from './types';

export type OfficialGroupsAction = OfficialGroupsLoadAction | OfficialGroupsLoadMoreAction;

const initialState: OfficialGroups = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<OfficialGroups, OfficialGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'OFFICIAL_GROUPS.LOAD_PENDING':
      return setPending();
    case 'OFFICIAL_GROUPS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'OFFICIAL_GROUPS.LOAD_FULFILLED':
      return setFulfilled({
        officialGroups: action.payload.entities.officialGroups,
        pageInfo: action.payload.entities.pageInfo,
      });
    case 'OFFICIAL_GROUPS.LOAD_MORE_FULFILLED':
      return setFulfilled({
        officialGroups: addAllToRecord(state.fulfilled?.officialGroups || {}, action.payload.entities.officialGroups),
        pageInfo: action.payload.entities.pageInfo,
      });
    default:
      return state;
  }
};

export default reducer;
